import { PURGE } from 'redux-persist';

// Multi-select filters hold arrays; free-text filters hold strings
export const INITIAL_FILTERS = {
  q: '', jobTitle: '', city: '',
  seniority: [], department: [], industry: [], country: [], state: [], employeeCount: [], revenue: [],
  hasEmail: true, hasPhone: true, hasLinkedin: true,
};

const initialState = {
  records: [],
  revealedData: {},
  inCrmMap: {},
  loading: false,
  revealLoading: false,
  revealingIds: {},
  error: null,
  hasSearched: false,
  pagination: { total: 0, page: 1, limit: 20 },
  filters: INITIAL_FILTERS,
  filterOptions: null,
  optionsLoading: false,
  creditsBalance: 0,
};

const Leads = (state = initialState, { type, payload }) => {
  switch (type) {
    case PURGE: return initialState;

    case 'SEARCH_LEADS': return { ...state, loading: true, error: null };
    case 'SET_LEADS': {
      const { total = 0, page = 1, limit = 20, pages = 1, data, inCrmMap = {}, revealed = [] } = payload;
      // Reason: /search returns records + CRM augmentation in one shot; absorb everything in a single transition
      const mergedRevealed = { ...state['revealedData'] };
      revealed.forEach(r => { if (r['prospectId']) mergedRevealed[r['prospectId']] = r; });
      return {
        ...state,
        loading: false,
        hasSearched: true,
        records: data || [],
        pagination: payload['pagination'] || { total, page, limit, pages },
        inCrmMap: { ...state['inCrmMap'], ...inCrmMap },
        revealedData: mergedRevealed,
      };
    }

    case 'REVEAL_LEADS': {
      const adding = {};
      (payload['prospectIds'] || []).forEach(id => { adding[id] = true; });
      return { ...state, revealLoading: true, revealingIds: { ...state['revealingIds'], ...adding } };
    }
    case 'SET_REVEALED_LEADS': {
      const merged = { ...state['revealedData'] };
      const remaining = { ...state['revealingIds'] };
      (payload['results'] || payload['data'] || []).forEach(r => {
        const id = r['prospectId'] || r['_id'];
        if (id) { merged[id] = r; delete remaining[id]; }
      });
      return { ...state, revealLoading: Object.keys(remaining).length > 0, revealingIds: remaining, revealedData: merged };
    }

    case 'SET_IN_CRM_MAP': return { ...state, inCrmMap: { ...state['inCrmMap'], ...payload } };

    case 'SET_LEADS_FILTERS': return { ...state, filters: { ...state['filters'], ...payload } };
    case 'GET_LEADS_FILTER_OPTIONS': return { ...state, optionsLoading: true };
    case 'SET_LEADS_FILTER_OPTIONS': return { ...state, filterOptions: payload, optionsLoading: false };
    case 'CLEAR_LEADS_SEARCH': return { ...state, filters: INITIAL_FILTERS, records: [], hasSearched: false, error: null, pagination: { total: 0, page: 1, limit: state['pagination']['limit'] } };
    case 'SET_LEADS_LOADING': return { ...state, loading: payload };
    case 'SET_REVEAL_LOADING': return { ...state, revealLoading: payload, revealingIds: payload ? state['revealingIds'] : {} };
    case 'SET_LEADS_ERROR': return { ...state, loading: false, revealLoading: false, revealingIds: {}, error: payload };
    case 'SET_LEADS_CREDITS': return { ...state, creditsBalance: payload };

    default: return state;
  }
};

export default Leads;
